import InputNumber from 'antd/es/input-number';
import 'antd/lib/input-number/style';
export default InputNumber;
